const EvaluationsIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 2C2.45 2 2 2.45 2 3V17C2 17.55 2.45 18 3 18H17C17.55 18 18 17.55 18 17V3C18 2.45 17.55 2 17 2H3ZM4 4H16V6H4V4ZM4 8H16V10H4V8ZM4 12H12V14H4V12Z"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);

export default EvaluationsIcon;
